module.exports = __webpack_public_path__ + "static/activity-zones-316eba3ab4c151f0d1de56e41e6fb0a8.png";